import axios from "axios";

// Create the axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        //"ngrok-skip-browser-warning": "true",
    },
});

// Request interceptor: attach Bearer token from localStorage
api.interceptors.request.use(
    (config) => {
        try {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            } else {
                const loginDetail = localStorage.getItem("loginDetail");
                if (loginDetail) {
                    const { token: detailToken } = JSON.parse(loginDetail);
                    if (detailToken) {
                        config.headers.Authorization = `Bearer ${detailToken}`;
                    }
                }
            }
        } catch (e) {
            // ignore parse errors
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Added a response interceptor
api.interceptors.response.use(
    (response) => response, // if it successful, let if pass
    (error) => {
        if (error.response?.status === 401) {
            // if token is expired
            alert("Session expired !, Please login again");
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            localStorage.removeItem("userName");
            localStorage.removeItem("loginDetail");
            window.location.href = "/login";
        }
        // Returned a rejected promise for further handling if needed
        return Promise.reject(error);
    }
);

export default api;
